import { forwardRef } from "react";
import { HashLink } from "react-router-hash-link";

// Where an element sits in the document by layout. `offsetTop` ignores transforms — on the
// element and on every ancestor — which is the whole point: see `scrollToSection`.
const layoutTop = (element) => {
  let top = 0;
  for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
  return top;
};

/**
 * Scrolls a `#hash` target to the top of the page, short of the header by its own
 * `scroll-margin-top`.
 *
 * Not `scrollIntoView`, which aims at where the element is *drawn*. A section that has not
 * revealed yet is drawn offset by its entrance — "Rólunk" 80px below its place — so arriving
 * from another page, the scroll landed 80px short of the section's real top and the reveal
 * then carried the heading up under the header. Clicking the same link again, with the
 * section already in place, landed right, which is what gave it away. Measured by layout,
 * where the section lands does not depend on whether it has revealed.
 */
export const scrollToSection = (element) => {
  const margin = parseFloat(window.getComputedStyle(element).scrollMarginTop) || 0;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  window.scrollTo({ top: layoutTop(element) - margin, behavior: reducedMotion ? "auto" : "smooth" });
};

/** A link to a section of a page, e.g. `/#about`: a `HashLink` that scrolls with `scrollToSection`. */
const SectionLink = forwardRef((props, ref) => (
  <HashLink ref={ref} scroll={scrollToSection} {...props} />
));

export default SectionLink;
